import { render, staticRenderFns } from "./GeneralInfoPanels.vue?vue&type=template&id=f1e94508&scoped=true"
import script from "./GeneralInfoPanels.vue?vue&type=script&lang=ts"
export * from "./GeneralInfoPanels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e94508",
  null
  
)

export default component.exports